module.exports = __webpack_public_path__ + "assets/ic_tree12.28822113.svg";